// RBLPaymentButton — "Pay PRO on-chain with R₿L (-50%)" entry point.
// Renders BELOW the existing payment rails in PremiumGate (additive).
import React, { useState, lazy, Suspense } from "react";
import { Wallet } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useLanguage } from "../../i18n/LanguageContext";

const RBLPaymentModal = lazy(() => import("./RBLPaymentModal"));

const T = {
  es: { divider: "o paga on-chain con tu wallet", btn: "Pagar con R₿L on-chain", badge: "-50%" },
  en: { divider: "or pay on-chain with your wallet", btn: "Pay with R₿L on-chain", badge: "-50%" },
  sk: { divider: "alebo zaplať on-chain peňaženkou", btn: "Zaplatiť s R₿L on-chain", badge: "-50%" }, de: { divider: "oder zahle on-chain mit deiner Wallet", btn: "Mit R₿L on-chain bezahlen", badge: "-50%" }, "zh-CN": { divider: "或使用钱包链上支付", btn: "使用 R₿L 链上支付", badge: "-50%" },
};

export default function RBLPaymentButton() {
  const { user, openLogin } = useAuth();
  const { lang } = useLanguage();
  const t = T[lang] || T.en || T.es;
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-4" data-testid="rbl-onchain-section">
      <div className="relative my-2 flex items-center justify-center">
        <span className="absolute inset-x-0 top-1/2 h-px bg-white/10" />
        <span className="relative bg-zinc-950 px-3 font-mono text-[9px] uppercase tracking-[0.3em] text-white/40">
          {t.divider}
        </span>
      </div>
      <button
        onClick={() => (user ? setOpen(true) : openLogin())}
        data-testid="rbl-onchain-open-btn"
        className="group relative inline-flex w-full items-center justify-center gap-2 overflow-hidden rounded-xl border py-3 text-xs font-black uppercase tracking-[0.2em] text-white transition-all hover:-translate-y-0.5"
        style={{ borderColor: "rgba(249,115,22,0.5)", background: "linear-gradient(135deg,rgba(109,40,217,0.18),rgba(249,115,22,0.12))" }}
      >
        <Wallet className="h-4 w-4" style={{ color: "#f97316" }} />
        {t.btn}
        <span className="rounded-full px-2 py-0.5 text-[9px] font-black" style={{ background: "#f97316", color: "#0a0a0f" }}>
          {t.badge}
        </span>
      </button>
      {open && (
        <Suspense fallback={null}>
          <RBLPaymentModal onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </div>
  );
}
